///<reference path="../../typings/browser.d.ts" />
"use strict";
var SampleModuleCtrl_1 = require('./SampleModuleCtrl');
var SampleModulePopCtrl_1 = require('./SampleModulePopCtrl');
exports.name = 'SampleModule';
exports.angularModule = angular.module(exports.name, [])
    .directive('sampleModule', function () {
    return {
        restrict: 'E',
        scope: {
            word: '='
        },
        controller: SampleModuleCtrl_1.SampleModuleCtrl,
        controllerAs: 'ctrl',
        template: require('./sampleModule.html')
    };
})
    .directive('sampleModulePop', function () {
    return {
        restrict: 'E',
        scope: {
            word: '='
        },
        controller: SampleModulePopCtrl_1.SampleModulePopCtrl,
        controllerAs: 'ctrl',
        template: require('./sampleModulePop.html')
    };
});
//# sourceMappingURL=index.js.map